import React, { useState, useEffect } from 'react'
import '../App.scss';
import './Items.scss'
import { makeStyles } from '@material-ui/core/styles';
import { Link, useLocation } from 'react-router-dom'
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Box from '@material-ui/core/Box';
import { ReactComponent as Logo } from '../image/logosvg.svg'
import { ReactComponent as Maps } from '../image/hmr_maps.svg'
import { ReactComponent as BusinessIntelligenceSolutions } from '../image/Business_Intelligence_Solutions.svg'
import { ReactComponent as Consulting } from '../image/Consulting.svg'
import { ReactComponent as MarketAnalysis } from '../image/Market_Analysis.svg'
import { ReactComponent as MarketingManager } from '../image/Marketing_Manager.svg'
import { ReactComponent as SalesManagement } from '../image/Sales_Management.svg'
import { ReactComponent as SupplyChainOptimization } from '../image/Supply_Chain_Optimization.svg'
import axios from 'axios';
import { useHistory } from 'react-router';
import Header from './Header';
import TextField from '@material-ui/core/TextField';
import ReactPlayer from 'react-player'
import { findDOMNode } from 'react-dom'
import screenfull from 'screenfull'
import '../image/HD720_HMR_Haia.mp4'
import '../image/HMR-myHMR-Banner.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

const isFirefox = typeof InstallTrigger !== 'undefined';
const isIE = /*@cc_on!@*/false || !!document.documentMode;
const testIE = false;
const haiaThoughSpot = 'https://www.thoughtspot.com/'

const chooseIconDocumentType = (iconname) => {
  switch(iconname.toLowerCase()) {
    case '/image/business_intelligence_solutions':
      return <BusinessIntelligenceSolutions width="100" height="100" className="itemWidth"/>
    case '/image/consulting':
      return <Consulting width="100" height="100" className="itemWidth"/>
    case '/image/market_analysis':
      return <MarketAnalysis width="100" height="100"className="itemWidth"/>
    case '/image/marketing_manager':
      return <MarketingManager width="100" height="100" className="itemWidth"/>
    case '/image/sales_management':
      return <SalesManagement width="100" height="100" className="itemWidth"/>
    case '/image/supply_chain_optimization':
      return <SupplyChainOptimization width="100" height="100" className="itemWidth"/>
  }
}
const useStyles = makeStyles(theme => ({

    submit: {
        border: '2px solid',
        margin: theme.spacing(3, 0, 2),
      },
    topButton: {
        border: '1px solid #18EA95',
        textDecoration: 'none',
        "&:hover, &:focus": {
            cursor: 'pointer',
            backgroundColor: '#18EA95',
            color: '#FFFFFF'
          }
    },
    root: {
      height: '100vh',
    },
    image: {
      backgroundImage: 'url(https://source.unsplash.com/random)',
      backgroundRepeat: 'no-repeat',
      backgroundColor:
        theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    paper: {
      margin: theme.spacing(8, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    modal: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
      padding: '70px',
      width: '300px',
      textAlign: 'center'
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    paper: {
        position: 'absolute',
        width: 450,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    buttonForgot: {
      fontSize: '20px',
      textDecoration: 'none',
      "&:hover, &:focus": {
        cursor: 'pointer'
      },
      "&:visited": {
        color: '#FFFFFF'
      }
    },
    searchButton: {
        color: '#18EA95'
    },
    closeButton: { cursor:'pointer', float:'right', marginTop: '5px', width: '20px' },
    inputLabel: {
        color: "#00000",
        fontSize: '20px',
        "&.focused": {
          color: "#18EA95",
          //border: "2px solid #18EA95",
          fontSize: "20px"
        },
        '&.MuiInput-underline:after': {
          borderBottomColor: '#18EA95',
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: "#18EA95",
          },
          '&:hover fieldset': {
            borderColor: "#18EA95",
          },
          '&.Mui-focused fieldset': {
            borderColor: "#18EA95",
          }
        }
      },
      inputLabelProps: {
        color: '#18EA95',
        fontSize: '20px',
        "&.focused": {
          color: "#18EA95",
          //border: "2px solid #18EA95",
          fontSize: "20px"
        },
      },
      underline: {
        color: "#18EA95" ,
        '&::after': {
          border: '2px solid #18EA95'
        }
      }
  }));

const onGetQVLink = (item) => {
    var username = localStorage.getItem('username') || '';
    var password = localStorage.getItem('password') || '';

    //var appType = QVWID > 0 ? "qlikview" : "dwWebApp";
    var newWindow = window.open();
    axios.post('/api/getQVLink', { 
        username: username, 
        password: password, 
        app: item.ClaimType, 
        role: 'user', 
        claim: null, 
        QVWID: item.QVWId, 
        datasetVersionId: item.DatasetVersionId, 
        culture: item.Culture 
    }).then((result) => {
        newWindow.location = result.data.redirectLink;
    })
}

function ItemMap(props) {
  var cleanDescription = props.item.Description.replace(/_/g, ' ');
  return <a target="_blank" onClick={() => onGetQVLink(props.item, 0)}><div key="firstItem" className="tiles lightGreyBackground">
            <div key={props.index + "img"} className="tilesImg text28"><div><span className="white">{ renderMosaicoSwitch(props.item.ClaimType, props.item.ImagePath) }
                      </span><span className="lightGreen fontArial">.</span></div></div>
                    <span title={props.item.Description} className="tilesText">{cleanDescription}</span>
          </div>
          </a>
}

function renderMosaicoSwitch(ClaimType, name) {
  switch(ClaimType) {
    case 0: 
        return name
    case 1:
        return name
    default:
        return "Distribution Watch"
  }
}

function Item(props) {
    var description = props.item.Description.length > 45 ? 
                              props.item.Description.substring(0,45) + "..." : props.item.Description
    var cleanDescription = description.replace(/_/g, ' ');
          
    return <a target="_blank" onClick={() => onGetQVLink(props.item)}>
                <div key={props.index + "div"} class="tiles">
                    <div key={props.index + "img"} className="tilesImg text28"><div><span className="white">{ renderMosaicoSwitch(props.item.ClaimType, props.item.ImagePath) }
                      </span><span className="lightGreen fontArial">.</span></div></div>
                    <span title={props.item.Description} className="tilesText">{cleanDescription}</span>
                </div>
            </a>
}

function ItemHaia() {
  // var description = props.item.Description.length > 45 ? 
  //                           props.item.Description.substring(0,45) + "..." : props.item.Description
  // var cleanDescription = description.replace(/_/g, ' ');
        
  return <a target="_blank" href={haiaThoughSpot}>
              <div key={"haiadiv"} class="tiles">
                  <div key={"haiaimg"} className="tilesImg text28"><div><span className="white"> HAIA
                    </span><span className="lightGreen fontArial">.</span></div></div>
                  <span title='This is Haia' className="tilesText">This is Haia</span>
              </div>
          </a>
}

const searchItems = (items) => {
  var maps = []; 
  var itemList = [];
  if(items) {
    itemList = items.filter((item) => {
        return item.ClaimType !== 0;
    })
    maps = items.filter((item) => {
        return item.ClaimType === 0;
    })
  }

  return { maps, itemList }
}

//const onClickFullscreen = () => {
//  screenfull.request(findDOMNode(this.refs.player))
//}

const ItemList = (props) => {
    const location = useLocation();
    const history = useHistory();
    const [search, setSearch] = useState('')
    var maps = [];
    var items = [];
    
    var filteredLists = location.state ? searchItems(location.state.items) : { maps: [], itemList: [] }

    const [ItemListState, setItemListState] = useState(filteredLists ? filteredLists.itemList : [])
    const [mapsState, setMapsState] = useState(filteredLists ? filteredLists.maps : [])
    const [oriItemListState, setOriItemListState] = useState(location.state ? location.state.items : [])
    const [username, setUsername] = useState(location.state ? location.state.username : [])
    const [haiaState, setHaia] = useState(location.state ? location.state.haia : [])
    const [countryState, setCountry] = useState(location.state ? location.state.country : [])
    const [auxiliarydocuments, setAuxiliarydocuments] = useState(location.state ? location.state.auxiliarydocuments : [])
    const classes = useStyles();

    

    const handleSearchChange = (e) => {
        const term = e.currentTarget.value;
        var filterResults = { maps: [], itemList: [] }

        if(term.trim().length !== 0) {
            var filteredlist = oriItemListState.filter((w) => {
                return w.Description.toLowerCase().includes(term.toLowerCase()) 
                  || w.ImagePath.toLowerCase().includes(term.toLowerCase()) 
                  || (w.ClaimType === 2 || w.ClaimType == 3) && "Distribution Watch".toLowerCase().includes(term.toLowerCase()) // Needs to be redesigned
            })
            filterResults = searchItems(filteredlist)
            
        } else {
            filterResults = searchItems(oriItemListState)
        }
        setItemListState(filterResults.itemList)
        setMapsState(filterResults.maps);
    }
    
    return (
            <div className="App">
              <Header  showMenu={true}/>
           {isIE && 
                    <div className="ieContainer">
                        <span className="ieTextStyle"><FontAwesomeIcon icon={faExclamationCircle} style={{ paddingRight: 10}} />
                            Please note that your browser will not provide all the features included in HMR Maps. For a full experience consider using a diferent browser.</span>
                    </div>
}
                <div className={`flexcontainer ${isIE ? "" : "flexcontainermarginZero"}`}>
                    <div className="column leftColumn">
                        <p className="text40"><span className="fontGilroyExtraBold">Your Services Portfolio</span><span className="lightGreen fontArial text40">.</span></p>
                        <p className="text18 lineHeight">To share the full power of knowledge we provide different types of solutions and skills, ensuring 
                            the most suitable level of service to all our clients, independently of the market segment or product life cycle stage.</p>
                        <p className="text14 lineHeight">To learn more about HMR Portfolio of solutions and services and how we can help you, please click below or contact your dedicated KAM.</p>
                        <p className="text20"><a target="_blank" href="http://hmr.co.com/" className="bodyButton"><div className="hAlign"><span>More Services</span></div></a></p>
                        { auxiliarydocuments.map((doc) => {
                          if(doc.Name == 'Documento Metodológico') {
                            return <div className="text16 padding3">To learn more about HMR way of work <a target="_blank" href={process.env.PUBLIC_URL + '/doc/?document=' + doc.Url}>Click here</a></div>
                          }
                          if(doc.Name == 'Legislacao') {
                            return <div className="text16 padding3">To learn more about the most recent legislation affecting the national health system <a target="_blank" href={process.env.PUBLIC_URL + '/doc/?document=' + doc.Url}>Click here</a></div>
                          }
                          if(doc.Name == 'Meio social') {
                            return <div className="text16 padding3">To learn more about social aspects <a target="_blank" href={process.env.PUBLIC_URL + '/doc/?document=' + doc.Url}>Click here</a></div> 
                          }
                        })}
                        
                          <div>
                            {
                            <div className="devRelative">
                              <img width="830" height="408" src={process.env.PUBLIC_URL + '/HMR-myHMR-Banner.png'}/>
                              <div className="devAbsoluteBottomRight">
                                <a target="_blank" href="https://haia.hmr.co.com/" className="bodyButtonFull"><div className="hAlign"><span>Login</span></div></a>
                              </div>
                            </div>
                          }
                            </div>
                    </div>
                    <div className="column rightColumn">
                        <div className="rightContainer">
                            <div className="searchField">
                            <Box display="flex" flexDirection="row-reverse">
                                <TextField
                                InputProps={{
                                    classes: {
                                      root: classes.inputLabel,
                                    }
                                  }}
                                  InputLabelProps={{
                                    classes: {
                                      root: classes.inputLabelProps,
                                      focused: "focused"
                                    }
                                  }}
                                    fullWidth="true"
                                    label="Search"
                                    InputProps={{
                                        endAdornment: (
                                        <InputAdornment>
                                            <IconButton>
                                            <SearchIcon className={classes.searchButton} />
                                            </IconButton>
                                        </InputAdornment>
                                        )
                                    }}
                                    onChange={handleSearchChange}
                                    />
                                    </Box>
                            </div>
                        </div>
                        <div className="container">
                            { mapsState && mapsState.map((item, index) => {
                                return <ItemMap item={item} index={index}/>
                              })
                            }
                            { ItemListState && ItemListState.map((item, index) => {
                                return <Item index={index} item={item}/>
                            })}
                        </div>
                    </div>
                </div>
            </div>
    )
};

export default ItemList;